<script setup lang="ts">
  import { reactiveOmit } from '@vueuse/core';
  import type { AlertDialogActionProps } from 'reka-ui';
  import { AlertDialogAction } from 'reka-ui';
  import type { HTMLAttributes } from 'vue';

  import { buttonVariants } from '@ui/components/button';
  import type { ButtonVariants } from '@ui/components/button';
  import { cn } from '@ui/utils/utils';

  const props = defineProps<
    AlertDialogActionProps & {
      class?: HTMLAttributes['class'];
      size?: ButtonVariants['size'];
      variant?: ButtonVariants['variant'];
    }
  >();

  const delegatedProps = reactiveOmit(props, 'class');
</script>

<template>
  <AlertDialogAction
    v-bind="delegatedProps"
    :class="cn(buttonVariants({ size, variant }), props.class)"
  >
    <slot />
  </AlertDialogAction>
</template>
